import { render } from "./paymentform.vue?vue&type=template&id=7d6ffef3&scoped=true"
import script from "./paymentform.vue?vue&type=script&lang=js"
export * from "./paymentform.vue?vue&type=script&lang=js"

import "./paymentform.vue?vue&type=style&index=0&id=7d6ffef3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6ffef3"]])

export default __exports__